import React, { createContext, useContext, useEffect, useState } from 'react';
import { UserContext } from '../UserContext';

const socketendpoint = process.env.REACT_APP_SOCKET_URL;
const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const { user, setUser } = useContext(UserContext);
    const [alert, setAlert] = useState(false);

    useEffect(() => {
        let ws;
        let reconnectTimer;
        let retryCount = 0;
        const maxRetries = 10;

        const acces = localStorage.getItem('acces');

        const connectWebSocket = () => {
            if (!acces || !user?.subscription || user.subscription.status !== 'active') return;

            ws = new WebSocket(`${socketendpoint}/ws/socket-server/?token=${acces}`);

            ws.onopen = () => {
                setSocket(ws);
                setAlert(false);
                retryCount = 0; // reset on successful connection
            };

            ws.onmessage = (message) => {
                const data = JSON.parse(message.data);

                if (data.field === 'message') {
                    if (user.id !== data.message["sender"]) {
                        setUser(prevUser => ({
                            ...prevUser,
                            messages: user.messages,
                            dialogues: user.dialogues,
                            notifications: [...prevUser.notifications, data.message["sender"]]
                        }));
                    }

                    if (data.message["new_user"]) {
                        user.dialogues.push(data.message["new_user"]);
                        user.messages.push({
                            id: data.message["id"],
                            text: data.message["text"],
                            sender: data.message["sender"],
                            receiver: data.message["receiver"],
                            date: data.message["date"]
                        });
                        setUser(prevUser => ({
                            ...prevUser,
                            messages: user.messages,
                            dialogues: user.dialogues,
                        }));
                    } else {
                        user.messages.push(data.message);
                        setUser(prevUser => ({
                            ...prevUser,
                            messages: user.messages,
                        }));
                    }
                }

                else if (data.field === 'more_messages') {
                    if (data.messages.length < 30 && data.messages.length > 0) {
                        user.last.push(data.messages[0]);
                    }
                    user.messages = [...data.messages, ...user.messages];
                    setUser(prevUser => ({
                        ...prevUser,
                        messages: user.messages,
                        last: user.last
                    }));
                }
            };

            ws.onclose = () => {
                if (maxRetries === retryCount) {
                    setAlert(true);
                }
                if (user?.subscription?.status === 'active' && retryCount < maxRetries) {
                    // if (user?.subscription?.status === 'active') {
                    // setAlert(true);
                    reconnectTimer = setTimeout(() => {
                        retryCount += 1;
                        connectWebSocket();
                    }, 3000); // 3 saniye sonra yeniden bağlanmayı dene
                }
            };
        };

        connectWebSocket();
        return () => {
            if (ws) ws.close();
            if (reconnectTimer) clearTimeout(reconnectTimer);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <WebSocketContext.Provider value={{ socket }}>
            {alert && <div className="alert alert-danger fixed-alert" role="alert">
                Your connection to the server has been lost. pls refresh the page !
            </div>}
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    return useContext(WebSocketContext);
};



// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { UserContext } from '../UserContext';
// const socketendpoint = process.env.REACT_APP_SOCKET_URL;
// const WebSocketContext = createContext(null);

// export const WebSocketProvider = ({ children }) => {
//     const [socket, setSocket] = useState(null);
//     const { user, setUser } = useContext(UserContext);
//     const [alert, setAlert] = useState(false);


//     useEffect(() => {
//         const acces = localStorage.getItem('acces');
//         const ws = new WebSocket(`${socketendpoint}/ws/socket-server/?token=${acces}`);
//         ws.onopen = () => {
//             setAlert(false);
//         };

//         ws.onmessage = (message) => {
//             const data = JSON.parse(message.data);

//             if (data.field === 'message') {

//                 if (user.id !== data.message["sender"]) {
//                     setUser(prevUser => ({
//                         ...prevUser,
//                         messages: user.messages,
//                         dialogues: user.dialogues,
//                         notifications: [...prevUser.notifications, data.message["sender"]]
//                     }));
//                 }

//                 if (data.message["new_user"]) {
//                     user.dialogues.push(data.message["new_user"]);

//                     user.messages.push({ "id": data.message["id"], "text": data.message["text"], "sender": data.message["sender"], "receiver": data.message["receiver"], "date": data.message["date"] });
//                     setUser(prevUser => ({
//                         ...prevUser,
//                         messages: user.messages,
//                         dialogues: user.dialogues,
//                     }));
//                 }

//                 else {
//                     user.messages.push(data.message);
//                     setUser(prevUser => ({
//                         ...prevUser,
//                         messages: user.messages,
//                     }));
//                 }
//             }

//             else if (data.field === 'more_messages') {
//                 if (data.messages.length < 30 && data.messages.length > 0) {
//                     user.last.push(data.messages[0]);
//                 }
//                 user.messages = [...data.messages, ...user.messages];
//                 setUser(prevUser => ({
//                     ...prevUser,
//                     messages: user.messages,
//                     last: user.last
//                 }));
//             }
//         };

//         ws.onclose = () => {
//             if (user.subscription.status === 'active') {
//             setAlert(true);
//             }
//             // alert('Your connection to the server has been lost.\nPlease refresh the page to reconnect.');
//             // console.log('Your connection to the server has been lost.\nPlease refresh the page to reconnect.');
//         };

//         setSocket(ws);
//         return () => {
//             ws.close();
//         };
//         // eslint-disable-next-line
//     }, []);

//     return (

//         <WebSocketContext.Provider value={{ socket }}>
//             {alert && <div className="alert alert-danger fixed-alert" role="alert">
//                 Your connection to the server has been lost. Please refresh the page to reconnect.
//             </div>}
//             {children}
//         </WebSocketContext.Provider>
//     );
// };

// export const useWebSocket = () => {
//     return useContext(WebSocketContext);
// };




